export default __webpack_public_path__ + "static/media/background.b91f7f66.jpg";